import {
  faArrowRight, // вход/переход вперёд
  faArrowLeft, // выход/переход назад
  faUpRightFromSquare, // переход/выход из воронки
  faEnvelope, // отправка сообщения
  faRobot, // робот
  faClipboard, // создание задачи
  faTag, // установка тега
  faKey, // сообщение по ключевым словам
} from '@fortawesome/free-solid-svg-icons';

import type { NFunnels } from '@app/types';

import type { IconDefinition } from '@fortawesome/free-solid-svg-icons';

export const getRobotIcon = (
  robotType: NFunnels.SalesFunnelRobotDto['Type']
): IconDefinition => {
  switch (robotType) {
    case 1:
      return faArrowRight; // Переход в этап воронки
    case 2:
      return faArrowLeft; // Переход из этапа воронки
    case 3:
      return faUpRightFromSquare; // Переход из воронки
    case 4:
      return faClipboard; // Создание задачи
    case 5:
      return faTag; // Установка тега
    case 6:
      return faKey; // Сообщение по ключевым словам
    case 100:
      return faEnvelope; // Отправить сообщение
    default:
      return faRobot; // fallback
  }
};
